module.exports = __webpack_public_path__ + "media/iconic/social-b5cfd288.svg";